import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/site";

export default function FaqPreviewSection() {
  const preview = faqs.slice(0, 5);

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-[1240px] mx-auto px-4 md:px-10">
        <SectionHeading
          eyebrow="常见问题"
          title="读之前，你可能想先确认几件事"
          action={
            <Link
              to="/faq"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
            >
              查看全部问答
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          }
        />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-8">
            <FaqAccordion items={preview} defaultOpenId={preview[0]?.id} />
          </div>
          <aside className="lg:col-span-4">
            <div className="rounded-lg bg-secondary-50 border border-secondary-200 p-5 md:p-6">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-500 text-background-50 text-xl mb-4">
                <i className="ri-question-answer-line" aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                没找到答案？
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                把你的疑问和线索一起发过来，我们看到后会整理进后续的档案里。
              </p>
              <Link
                to="/about#submit"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-secondary-800 hover:text-secondary-950"
              >
                联系与投稿
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}